import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../Layout';
import LoginForm from './LoginForm';

const EntitiesLogin = ({ onRecoveryBtn }) => {
  return (
    <Layout withoutNavOptions>
      <div className="Login">
        <h2 className="efpa-h2 efpa-text toUppercase Login-title">
          Intranet responsables
        </h2>
        <div className="Login-content w-100 justify-content-center">
          <LoginForm type="entities" onRecoveryBtn={onRecoveryBtn} />
        </div>
      </div>
    </Layout>
  );
};

EntitiesLogin.propTypes = {
  onRecoveryBtn: PropTypes.func,
};

export default EntitiesLogin;
